import React from 'react';
import Accessory from './Accessory';
import config from '../../../config';
import { Element, scroller } from 'react-scroll';
import TrackedButtonLink from "../../common/TrackedButtonLink";

class Accessories extends React.Component {
	componentDidMount() {
		if (global.location.hash === '#accessories') {
			global.setTimeout(() => {
				scroller.scrollTo('accessories', {
					offset: -45
				});
			}, 50);
		}
	}

	render() {
		const accessoriesList = this.props.accessories.map((accessory, index) => {
			return <Accessory accessory={ accessory } key={ index } />;
		});

		return (
			<section className="product-accessories" id="product-accessories">
				<Element name="accessories">
					<div className="row safes-callout">
						<div className="col sm-3 callout-descr">
							<h2 className="section-title">
								Add Interior Accessories
							</h2>
							<p>Customize your safe to fit your needs.</p>
							<TrackedButtonLink
								className="btn btn-primary"
								to={`${config.storeUrl}/collections/safe-accessories`}
							>
								View All Accessories
							</TrackedButtonLink>
						</div>
						<div className="col sm-9 products">
							<ul>
								{ accessoriesList }
							</ul>
						</div>
					</div>
				</Element>
			</section>
		);
	}
}

export default Accessories;


// WEBPACK FOOTER //
// ./src/pages/product/accessories/AccessoriesContainer.js